// makeEwsRequestAsync caps the size of the response it will hand back. Exceeding
// the cap surfaces as a generic 9020 (GenericResponseError) with no response body.
// Cap is 1 MB on classic desktop Outlook before Version 2303 (build 16225.10000),
// and 5 MB on newer desktop builds and Outlook on the web / new Outlook on Windows.
// https://learn.microsoft.com/javascript/api/outlook/office.mailbox#outlook-office-mailbox-makeewsrequestasync-member(1)
const LEGACY_CAP_BYTES = 1024 * 1024;
const MODERN_CAP_BYTES = 5 * 1024 * 1024;

const MODERN_WINDOWS_BUILD = 16225; // Windows Version 2303 (build 16225.10000)

export const getEwsResponseSizeCap = (): number => {
  const diagnostics = Office.context.mailbox?.diagnostics;

  // Web and new Outlook on Windows always support the 5 MB cap.
  if (diagnostics?.hostName !== 'Outlook') return MODERN_CAP_BYTES;

  // Windows classic format e.g. "16.0.16225.10000" — build is the third segment.
  // Mac (different format) and any unparseable version yield NaN → safe 1 MB fallback.
  const build = Number(diagnostics.hostVersion?.split('.')[2]);
  return build >= MODERN_WINDOWS_BUILD ? MODERN_CAP_BYTES : LEGACY_CAP_BYTES;
};
